"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../typography/index");
const createTheme_1 = __importDefault(require("@mui/material/styles/createTheme"));
const index_2 = require("../palettes/index");
const responsiveFontSizes_1 = __importDefault(require("@mui/material/styles/responsiveFontSizes"));
const lightThemeShared_1 = require("./lightThemeShared");
const theme = (0, createTheme_1.default)({
    palette: index_2.facilityLightPalette,
    shape: {
        borderRadius: 4,
    },
    typography: index_1.typography,
});
const shared = (0, lightThemeShared_1.getSharedComponents)(theme);
//@ts-ignore
theme.components = {
    ...shared,
};
const facilityLightTheme = (0, responsiveFontSizes_1.default)(theme);
exports.default = facilityLightTheme;
